<div class="bcg p-4">
  <div class="d-flex justify-content-between custom-container">
    <nav class="custom-nav">
      <ol class="breadcrumb">
        <li
          *ngIf="userRole === 'CLIENT'; else showAdminDashboard"
          class="breadcrumb-item"
          style="cursor: pointer"
          [routerLink]="'/doqfy/dashboard'"
        >
          Dashboard
        </li>
        <ng-template #showAdminDashboard>
          <li
            class="breadcrumb-item"
            style="cursor: pointer"
            [routerLink]="'/doqfy/admin-dashboard'"
          >
            Dashboard
          </li>
        </ng-template>
        <li
          class="breadcrumb-item active"
          style="cursor: context-menu"
          aria-current="page"
        >
          Pre-procurement
        </li>
      </ol>
    </nav>
  </div>

  <div class="card card_outLine mt-3">
    <div class="card-body">
      <!-- ── Row 1: Title (left) | Buttons (right) ── -->
      <div class="row mx-1 align-items-center mb-3">
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5 class="title_five mb-0">Pre-procurement</h5>
        </div>
        <div
          class="col-lg-7 col-md-7 col-sm-12 d-flex justify-content-end gap-2"
        >
          <ng-container *ngIf="orderOption.tabIndex === 0">
            <app-button
              *ngIf="canCreatePreProcurement"
              label="Create new order"
              [routerLink]="['/doqfy/pre-procurement/procurement-create']"
              variant="primary"
              size="md"
            ></app-button>
            <app-button
              *ngIf="canCreatePreProcurement"
              label="Bulk Upload"
              variant="primary"
              size="md"
              (clicked)="openBulkUpload()"
            ></app-button>
            <app-button
              label="Back"
              variant="primary"
              size="md"
              (clicked)="back()"
            ></app-button>
          </ng-container>
          <ng-container *ngIf="orderOption.tabIndex === 1">
            <app-button
              *ngIf="!isClient"
              label="Export"
              variant="primary"
              size="md"
              (clicked)="export()"
            ></app-button>
            <app-button
              label="Procurement Report"
              variant="primary"
              size="md"
              icon="file-export"
              (clicked)="openReportModal()"
            ></app-button>
            <app-button
              label="Back"
              variant="outline"
              size="md"
              (clicked)="back()"
            ></app-button>
          </ng-container>
        </div>
      </div>

      <!-- ── Row 2: Tabs → Filters above grid → Grid ── -->
      <app-tab-view
        [tabs]="procurementTabs"
        [activeIndex]="orderOption.tabIndex"
        (tabChange)="onChangeTab($event)"
      >
        <!-- ══ Bulk Tab ══ -->
        <ng-container *ngIf="orderOption.tabIndex === 0">
          <!-- Filters: right-aligned, above grid -->
          <div class="pp-filters">
            <div class="pp-filters__control">
              <app-search-input
                [(ngModel)]="searchText"
                (ngModelChange)="onChangeSearchText($event)"
                placeholder="Search by Order ID"
              >
              </app-search-input>
            </div>
            <div class="pp-filters__control">
              <p-datepicker
                class="custom-calendar"
                [(ngModel)]="rangeDates"
                (onSelect)="onSelect()"
                placeholder="Filter Range"
                [showIcon]="true"
                iconDisplay="input"
                [maxDate]="maxDate"
                selectionMode="range"
                inputId="range"
                [showButtonBar]="true"
                appendTo="body"
                (ngModelChange)="onDateRangeChange($event)"
                dateFormat="dd/mm/yy"
              >
              </p-datepicker>
            </div>
            <div class="pp-filters__control">
              <app-dropdown
                [options]="accountUserData"
                class="custom-dropdown"
                placeholder="Select Account"
                optionLabel="account_name"
                optionValue="account_id"
                [filter]="true"
                [(ngModel)]="selectedAccount"
                filterBy="account_name"
                (onChange)="onSelectedAccount($event)"
                (onFilter)="onAccountFilter($event)"
              >
              </app-dropdown>
            </div>
            <div
              *ngIf="isDateRangeValid"
              class="pp-filters__control pp-filters__control--auto"
            >
              <app-button
                label="Download All"
                variant="outline"
                size="md"
                icon="download"
                (clicked)="getSelectedOrderCsv()"
              ></app-button>
            </div>
            <div class="pp-filters__control pp-filters__control--auto">
              <app-column-chooser [table]="bulkTable"></app-column-chooser>
            </div>
          </div>
          <!-- Bulk Grid -->
          <div class="table-responsive mt-2">
            <app-data-table
              #bulkTable
              [columnChooser]="true"
              [columns]="bulkColumns"
              [data]="orderList"
              [totalRecords]="totalRecords"
              [rows]="rowsPerPage"
              [paginator]="true"
              [analyticsTab]="'Pre-Procurement Bulk'"
              emptyMessage="No Records Found"
              (pageChange)="onPageChange($event)"
              (rowsChange)="onRowsPerPageChange($event)"
              (rowClick)="viewDetails($event)"
            >
              <ng-template appTableCell="total_balance" let-row>
                ₹{{ row.total_balance }}
              </ng-template>

              <ng-template appTableCell="status" let-row>
                <span
                  class="status-badge"
                  [ngClass]="{
                    completed: row.status === 'COMPLETED',
                    'in-progress': row.status === 'IN_PROGRESS',
                    initiated: row.status === 'INITIATED',
                    waitForAprove:
                      row.status === 'WAITING_FOR_APPROVAL' ||
                      row.status === 'WAITING_FOR_STAMP',
                    rejected: row.status === 'REJECTED',
                  }"
                  >{{ row.status | titlecase }}</span
                >
              </ng-template>

              <ng-template appTableCell="action" let-row>
                <div class="d-flex align-items-center gap-2" appRowActionStop>
                  <a
                    class="clickable"
                    appIconAction
                    (click)="viewDetails(row)"
                    ><i class="pi pi-eye"></i
                  ></a>
                  <a
                    class="viewmore"
                    (click)="getProcurmentSummary(row)"
                    data-bs-toggle="modal"
                    data-bs-target="#summaryModal"
                    ><i class="pi pi-book" pTooltip="View Summary"></i
                  ></a>
                  <a
                    class="viewmore"
                    (click)="exportProcurmentReport(row)"
                  >
                    <i
                      class="bx bx-download"
                      style="font-size: 19px"
                      pTooltip="Export Report"
                    ></i>
                  </a>
                  <a
                    *ngIf="row.reviewer_info.length !== 0"
                    class="clickable"
                    pTooltip="Approve Order Status"
                    (click)="approveOrderStatus(row)"
                  >
                    <i class="pi pi-folder-open"></i>
                  </a>
                </div>
              </ng-template>
            </app-data-table>
          </div>
        </ng-container>

        <!-- ══ Individual Tab ══ -->
        <ng-container *ngIf="orderOption.tabIndex === 1">
          <!-- Filters: right-aligned, above grid -->
          <div class="pp-filters">
            <div class="pp-filters__control">
              <app-search-input
                [(ngModel)]="individualProcurementIdSearch"
                (ngModelChange)="onIndividualProcurementSearch($event)"
                placeholder="Search by Procurement ID"
              >
              </app-search-input>
            </div>
            <div class="pp-filters__control">
              <app-dropdown
                [options]="states"
                class="custom-dropdown"
                placeholder="Select State"
                [(ngModel)]="selectedState"
                optionLabel="state_name"
                optionValue="state_code"
                [showClear]="true"
                (onChange)="onStateChange($event)"
              >
              </app-dropdown>
            </div>
            <div class="pp-filters__control">
              <p-datepicker
                class="custom-calendar"
                [(ngModel)]="individualRangeDates"
                placeholder="Filter Range"
                [showIcon]="true"
                iconDisplay="input"
                [maxDate]="maxDate"
                selectionMode="range"
                inputId="individualRange"
                [showButtonBar]="true"
                appendTo="body"
                (ngModelChange)="individualDateRangeChange($event)"
                dateFormat="dd/mm/yy"
              >
              </p-datepicker>
            </div>
            <div class="pp-filters__control pp-filters__control--auto">
              <app-column-chooser [table]="individualTable"></app-column-chooser>
            </div>
          </div>
          <!-- Individual Grid -->
          <div class="table-responsive mt-2">
            <app-data-table
              #individualTable
              [columnChooser]="true"
              [columns]="individualColumns"
              [data]="individualProcurementList"
              [totalRecords]="individualTotalRecords"
              [rows]="individualRowsPerPage"
              [paginator]="true"
              [analyticsTab]="'Pre-Procurement Individual'"
              emptyMessage="No Records Found"
              (pageChange)="individualOnPageChange($event)"
              (rowsChange)="individualOnRowsPerPageChange($event)"
              (rowClick)="exportIndividualProcurement($event)"
            >
              <ng-template appTableCell="balance" let-row>
                ₹{{ row.balance }}
              </ng-template>

              <ng-template appTableCell="status" let-row>
                <span
                  class="status-badge"
                  [ngClass]="{
                    completed: row.status === 'COMPLETED',
                    'in-progress': row.status === 'IN_PROGRESS',
                    initiated: row.status === 'INITIATED',
                    waitForAprove:
                      row.status === 'WAITING_FOR_APPROVAL' ||
                      row.status === 'WAITING_FOR_STAMP',
                    rejected: row.status === 'REJECTED',
                  }"
                  >{{ row.status | titlecase }}</span
                >
              </ng-template>

              <ng-template appTableCell="action" let-row>
                <div class="individual-row-actions" appRowActionStop>
                  <app-button
                    icon="eye"
                    variant="outline"
                    size="sm"
                    [iconOnly]="true"
                    [iconOnlyBorderless]="true"
                    title="View procurement notes"
                    ariaLabel="View procurement notes"
                    (clicked)="preProcurementNotes.openNotes(row.id)"
                  ></app-button>
                  <a
                    class="viewmore"
                    appIconAction
                    (click)="exportIndividualProcurement(row)"
                    pTooltip="Export Report"
                  >
                    <i class="bx bx-download" style="font-size: 19px"></i>
                  </a>
                </div>
              </ng-template>
            </app-data-table>
          </div>
        </ng-container>
      </app-tab-view>
    </div>
  </div>
</div>

<app-pre-procurement-notes #preProcurementNotes></app-pre-procurement-notes>

<!-- Summary Modal -->
<div
  class="modal fade"
  id="summaryModal"
  tabindex="-1"
  aria-labelledby="summaryModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="p-3 modal-title">
        <p>Summary</p>
        <app-button
          icon="times"
          variant="outline"
          size="sm"
          [iconOnly]="true"
          [iconOnlyBorderless]="true"
          ariaLabel="Close"
          (clicked)="closeSummaryModal()"
        ></app-button>
      </div>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="r1">
              Order No :<span class="r1s">{{ summaryData.order_id }}</span>
            </div>
          </div>
          <div class="col">
            <div class="r1">
              Organisation:<span class="r1s">{{
                summaryData.organisation
              }}</span>
            </div>
          </div>
          <div class="col">
            <div class="r1">
              Account:<span class="r1s">{{ summaryDetails[0]?.account }}</span>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <div class="r1">
              Ordered By:<span class="r1s">{{ summaryData.order_by }}</span>
            </div>
          </div>
          <div class="col">
            <div class="r1">
              Ordered Date:<span class="r1s">{{
                summaryData.order_date | date
              }}</span>
            </div>
          </div>
          <div class="col">
            <div class="r1">
              Total Amount:<span class="r1s"
                >₹{{ summaryData.total_balance }}</span
              >
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <div class="r1">
              Pre procurement order count:<span class="r1s">{{
                preProcurementCount?.procurement_order_count
              }}</span>
            </div>
          </div>
          <div class="col">
            <div class="r1">
              Procured stamps:<span class="r1s">{{
                preProcurementCount?.procured_stamps
              }}</span>
            </div>
          </div>
          <div class="col">
            <div class="r1">
              To be procured stamps:<span class="r1s">{{
                preProcurementCount?.to_be_procured
              }}</span>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <div class="r1">
              Consumed stamps:<span class="r1s">{{
                preProcurementCount?.consumed_stamps
              }}</span>
            </div>
          </div>
          <div class="col">
            <div class="r1">
              Available stamps:<span class="r1s">{{
                preProcurementCount?.available_stamps
              }}</span>
            </div>
          </div>
          <div class="col">
            <div class="r1">
              Blocked stamps:<span class="r1s">{{
                preProcurementCount?.blocked_stamps
              }}</span>
            </div>
          </div>
        </div>
        <div class="mb-4"></div>
      </div>
      <div class="p-3 modal-title"><p>State wise details</p></div>
      <div class="container mb-5">
        <div class="mt-1">
          <app-data-table
            [columns]="summaryColumns"
            [data]="summaryDetails"
            [paginator]="false">
          </app-data-table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Procurement Report Modal -->
<div
  class="modal fade"
  id="reportModal"
  tabindex="-1"
  aria-labelledby="reportModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="p-3 modal-title">
        <p>Procurement Report</p>
        <app-button
          icon="times"
          variant="outline"
          size="sm"
          [iconOnly]="true"
          [iconOnlyBorderless]="true"
          ariaLabel="Close"
          (clicked)="closeReportModal()"
        ></app-button>
      </div>
      <div class="container p-3">
        <div class="row g-2">
          <div class="col-md-6">
            <label class="form-label">Procurement ID</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter Procurement ID"
              [(ngModel)]="reportFilters.pre_procurement_id"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label">Certificate Number</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter Certificate Number"
              [(ngModel)]="reportFilters.certificate_number"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label"
              >State <span class="text-danger">*</span></label
            >
            <app-dropdown
              [options]="states"
              class="custom-dropdown w-100"
              placeholder="Select State"
              [(ngModel)]="reportFilters.state_code"
              optionLabel="state_name"
              optionValue="state_code"
              [showClear]="true"
            >
            </app-dropdown>
          </div>
          <div class="col-md-6">
            <label class="form-label">Status</label>
            <app-dropdown
              [options]="statusOptions"
              class="custom-dropdown w-100"
              placeholder="Select Status"
              [(ngModel)]="reportFilters.st_status"
              optionLabel="name"
              optionValue="code"
              [showClear]="true"
            >
            </app-dropdown>
          </div>
          <div class="col-md-6">
            <label class="form-label"
              >Procured Date Range <span class="text-danger">*</span></label
            >
            <p-datepicker
              class="custom-calendar w-100"
              [(ngModel)]="reportProcuredDates"
              placeholder="Select Date Range"
              [showIcon]="true"
              iconDisplay="input"
              [maxDate]="maxDate"
              selectionMode="range"
              [showButtonBar]="true"
              (ngModelChange)="onReportProcuredDateChange($event)"
              dateFormat="dd/mm/yy"
            >
            </p-datepicker>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <app-button
          label="Cancel"
          variant="primary"
          size="md"
          (clicked)="closeReportModal()"
        ></app-button>
        <app-button
          label="Download"
          variant="primary"
          size="md"
          icon="download"
          (clicked)="downloadProcurementReport()"
        ></app-button>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog
  [style]="{ width: '50vw' }"
  rejectButtonStyleClass="p-button-text"
></p-confirmDialog>
<p-toast></p-toast>
